import { Stack, Typography, styled } from "@mui/material";

export const StackFooter = styled(Stack)(({ theme }) => ({
  marginBottom: "0px !important",
  paddingTop: "0px",
  gap: "8px",
  flexWrap: "wrap",
  justifyContent: "center",
  alignItems: "center",
  [theme.breakpoints.down("lg")]: {
    gap: "4px",
  },
}));

export const TypographyButton = styled(Typography)(() => ({
  cursor: "pointer",
  "&:hover": {
    textDecoration: "underline",
  },
}));
